import clsx from "clsx";
import React from "react";
import { ImSpinner3 } from 'react-icons/im';

const NoData = ({
  isLoading,
  columns = [],
  hasActionColumn,
  hasSelectOption,
}) => {
  const getColSpan = () => {
    let colspan = columns.length;

    if (hasActionColumn) {
      colspan += 1;
    }

    if (hasSelectOption) {
      colspan += 1;
    }

    return colspan;
  };

  return (
    <tr className={clsx("datatable_grid-empty", { loading: isLoading })}>
      <td colSpan={getColSpan()}>
        {isLoading ? <ImSpinner3 className='no-data-spinner' /> : "No data found!"}
      </td>
    </tr>
  );
};

export default NoData;
